import { Icon } from '@rbilabs/universal-components';

import Link from 'components/link';
import { SAFE_AREA_TOP_INSET } from 'components/modal/constants';
import { withTypography } from 'components/ui';
import { primitive } from 'styles/constants';

import theme from './theme';

export const InnerText = withTypography({
  color: theme.innerColor,
  lineHeight: theme.innerLineHeight,
  variant: 'copyTwo',
  numberOfLines: 2,
});

export const InnerHeader = withTypography({
  color: primitive.$bbqBrown,
  lineHeight: 'lg',
  variant: 'headerTwo',
  focusable: true,
  style: {
    textTransform: 'capitalize',
  },
});

export const AmenityIcon = Icon.withConfig({
  color: primitive.$bbqBrown,
});

// `underline` draws the rule as a bottom border instead of textDecorationLine,
// which iOS breaks under round glyphs. lineHeight sits below fontSize on purpose:
// the border hangs off the line box, so a tight box keeps it against the text.
export const PhoneNumber = Link.withConfig({
  color: theme.phoneNumberColor,
  fontSize: 13,
  lineHeight: 13,
  fontWeight: '400',
  isInline: true,
  isUnderlined: false,
  underline: true,
  // Both must go through `style`: Typography maps only certain props into styles,
  // and layout props like these are not among them. alignSelf keeps the Text from
  // filling its flex row, which would run the rule past the digits; DirectionsLink
  // gets that from its wrapping View.
  style: {
    alignSelf: 'flex-start',
    marginTop: 6,
  },
});

export const STORE_INFO_MAP_HEIGHT = 175 + SAFE_AREA_TOP_INSET;
